export const RawBotType = Object.freeze({
	bot: 'bot',
	network: 'network',
	support24: 'support24',
	human: 'human',
	openline: 'openline',
	supervisor: 'supervisor',
	personal: 'personal',
});

export const BotType = Object.freeze({
	bot: 'bot',
	network: 'network',
	support24: 'support24',
});

export const BotCode = Object.freeze({
	marta: 'marta',
	giphy: 'giphy',
	copilot: 'copilot',
	aiAssistant: 'AiAssistantBot',
});

export const BotCommand = Object.freeze({
	activate: 'activate',
});
